// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_banner-container__jpx5A {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.Banner_banner__2Xf5e {
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 8px 16px #f0f0f0;
  color: #393939;
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  min-height: 44px;
  padding: 4px 32px;
  width: 100%;
  /* font */
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}

.Banner_icon-message-container__yCB25 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
}

.Banner_neutral__szMSu {
  border-bottom: 2px solid #696969;
}

.Banner_error__3TCfy {
  border-bottom: 2px solid #d73a3d;
}

.Banner_warning__LiNZo {
  border-bottom: 2px solid #ffb93c;
}

.Banner_info__oP4E5 {
  border-bottom: 2px solid #1175c9;
}

.Banner_success__H1RhO {
  border-bottom: 2px solid #4ba564;
}

.Banner_neutral-icon__geXos {
  color: #696969;
}

.Banner_error-icon__NRyHA {
  color: #d73a3d;
}

.Banner_warning-icon__sapNr {
  color: #ffb93c;
}

.Banner_info-icon__DCjui {
  color: #1175c9;
}

.Banner_success-icon__fbhtR {
  color: #4ba564;
}

.Banner_close__CDeM6 {
  color: #bbbbbb;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Banner/Banner.module.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,mBCFM;EDGN,kBAAA;EACA,gCAAA;EACA,cCRgB;EDShB,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,eEtBO;EFuBP,gBEhBU;EFiBV,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAFF;;AAKA;EACE,gCAAA;AAFF;;AAIA;EACE,gCAAA;AADF;;AAGA;EACE,gCAAA;AAAF;;AAEA;EACE,gCAAA;AACF;;AACA;EACE,gCAAA;AAEF;;AACA;EACE,cC7BY;AD+Bd;;AAAA;EACE,cC/BU;ADkCZ;;AADA;EACE,cCjCY;ADqCd;;AAFA;EACE,cCnCS;ADwCX;;AAHA;EACE,cCrCY;AD2Cd;;AAHA;EACE,cCxCY;AD8Cd","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.banner-container {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n}\n\n.banner {\n  align-items: center;\n  background: colors.$white;\n  border-radius: 8px;\n  box-shadow: 0px 8px 16px #f0f0f0;\n  color: colors.$secondary-hover;\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n  justify-content: space-between;\n  min-height: 44px;\n  padding: 4px 32px;\n  width: 100%;\n  /* font */\n  font-size: typography.$body-m;\n  font-weight: typography.$semi-bold;\n  line-height: 22px;\n}\n\n.icon-message-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n\n.neutral {\n  border-bottom: 2px solid colors.$neutral-200;\n}\n.error {\n  border-bottom: 2px solid colors.$error-200;\n}\n.warning {\n  border-bottom: 2px solid colors.$warning-200;\n}\n.info {\n  border-bottom: 2px solid colors.$info-200;\n}\n.success {\n  border-bottom: 2px solid colors.$success-300;\n}\n\n.neutral-icon {\n  color: colors.$neutral-200;\n}\n.error-icon {\n  color: colors.$error-200;\n}\n.warning-icon {\n  color: colors.$warning-200;\n}\n.info-icon {\n  color: colors.$info-200;\n}\n.success-icon {\n  color: colors.$success-300;\n}\n\n.close {\n  color: colors.$neutral-400;\n}\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner-container": `Banner_banner-container__jpx5A`,
	"banner": `Banner_banner__2Xf5e`,
	"icon-message-container": `Banner_icon-message-container__yCB25`,
	"neutral": `Banner_neutral__szMSu`,
	"error": `Banner_error__3TCfy`,
	"warning": `Banner_warning__LiNZo`,
	"info": `Banner_info__oP4E5`,
	"success": `Banner_success__H1RhO`,
	"neutral-icon": `Banner_neutral-icon__geXos`,
	"error-icon": `Banner_error-icon__NRyHA`,
	"warning-icon": `Banner_warning-icon__sapNr`,
	"info-icon": `Banner_info-icon__DCjui`,
	"success-icon": `Banner_success-icon__fbhtR`,
	"close": `Banner_close__CDeM6`
};
export default ___CSS_LOADER_EXPORT___;
